// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".access-blocked-banner[data-v-abcca1b8]{display:flex;align-items:flex-start;gap:8px;margin:8px 12px 4px;padding:10px 14px;background-color:#fff3cd;border:1px solid #ffc107;border-radius:6px;color:#664d03;font-size:13px;line-height:1.4}.access-blocked-icon[data-v-abcca1b8]{flex-shrink:0;font-style:normal}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
